module.exports = __webpack_public_path__ + "static/media/terrace-cgi.717382b3.jpg";